import React from 'react';

export const LoanBalanceObject = [
  {
    param: 'balances',
    type: 'object',
    required: true,
    object: [
      {
        param: 'interest_paid',
        type: 'string',
        required: true,
        description: (
          <p>
            Total paid interest in cents belonging to Column and your platform.
          </p>
        ),
      },
      {
        param: 'interest_receivable',
        type: 'string',
        required: true,
        description: (
          <p>
            Total outstanding interest receivable in cents for principal belonging to Column and your platform.
          </p>
        ),
      },
      {
        param: 'principal_charged_off',
        type: 'string',
        required: true,
        description: (
          <p>
            The charged-off principal receivable.
          </p>
        ),
      },
      {
        param: 'principal_holding',
        type: 'string',
        required: false,
        description: (
          <p>
            The principal receivable of the loan which is in a <code>holding</code> state.
          </p>
        ),
      },
      {
        param: 'principal_outstanding',
        type: 'string',
        required: true,
        description: (
          <p>
            The outstanding principal receivable of the loan belonging to Column and your platform.
          </p>
        ),
      },
      {
        param: 'principal_paid',
        type: 'string',
        required: true,
        description: (
          <p>
            The principal receivable of the loan which has been paid belonging to Column and your platform.
          </p>
        ),
      },
      {
        param: 'retained_interest_paid',
        type: 'string',
        required: false,
        description: (
          <p>
            Total paid interest in cents belonging to Column.
          </p>
        ),
      },
      {
        param: 'retained_interest_receivable',
        type: 'string',
        required: false,
        description: (
          <p>
            Total outstanding interest receivable in cents for principal belonging to Column.
          </p>
        ),
      },
      {
        param: 'retained_principal_outstanding',
        type: 'string',
        required: false,
        description: (
          <p>
            Total outstanding principal receivable in cents belonging to Column.
          </p>
        ),
      },
      {
        param: 'retained_principal_paid',
        type: 'string',
        required: false,
        description: (
          <p>
            Total paid principal receivable in cents belonging to Column.
          </p>
        ),
      },
      {
        param: 'servicing_fee_payable',
        type: 'string',
        required: false,
        description: (
          <p>
            Total outstanding servicing fee payable in cents to your platform.
          </p>
        ),
      },
    ],
  },
];
